import { useTranslations } from '@altermaind/core/i18n';
import { Box, Typography } from '@altermaind/web/ui';
import { Charts } from '@/_shared/components/Charts';
import { useBreakingPoints } from '@/_shared/hooks/useBreakpoint';
import { getSurveyCampaignByIdResponsesResultsStatsCall } from '@/surveys/state/api';

export const TeamDistributionBox = () => {
  const t = useTranslations('departments.tabs.team.assessment.distributionBox');
  const { teamStats } = getSurveyCampaignByIdResponsesResultsStatsCall.hook();

  const { isDesktop } = useBreakingPoints();

  return (
    <Box>
      <Typography variant='h3' mb='xxxs'>
        {t('title')}
      </Typography>
      <Typography variant='p3/light' mb='l'>
        {t('description')}
      </Typography>
      <Charts.StackedBarChartComponent
        total={teamStats?.totalCompletedSurveys || 0}
        data={teamStats?.metricsScore || []}
        defaultItemsSize={isDesktop ? 6 : 2}
      />
    </Box>
  );
};
